// Adresses et noms des fiches ville (/ou-investir/villes/{ville}/{cp}).
//
// Option A validée par Charly le 15/09/2026 : une seule adresse par ville, en minuscules.
// Google retenait déjà les versions en minuscules (bordeaux/33000, toulouse/31000, nantes/44000)
// alors que nos liens et nos plans du site utilisaient les majuscules : l'audience de chaque
// ville était coupée en deux adresses. Les liens (NuxtLink, routeur) mettent le nom en
// minuscules sans l'encoder, le routeur s'en charge ; la balise canonique et les plans du
// site utilisent le chemin encodé ci-dessous.

// Chemin encodé d'une fiche ville, nom en minuscules : balise canonique et plans du site.
export const cheminVilleEncode = (nom, cp) =>
  `/ou-investir/villes/${encodeURIComponent(String(nom ?? '').toLowerCase())}/${encodeURIComponent(String(cp ?? ''))}`

// Slug identique aux générateurs Python des données (scripts/gen-noms-communes.py).
export const slugVille = (s) => {
  if (!s) return ''

  return String(s)
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/['\s]+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
}

// Nom sans code postal final : la base des analyses contient des noms comme « Bordeaux 33000 ».
export const nomSansCodePostal = (nom) => String(nom ?? '').replace(/\s+\d{5}$/, '')

// Préfixe de fichier des données par code postal : 2 chiffres, 3 pour l'outre-mer
// (même découpage que data/rentabilite-villes).
export const prefixeCp = (cp) => {
  const code = String(cp ?? '')

  return code.startsWith('97') ? code.slice(0, 3) : code.slice(0, 2)
}

// Arrondissements de Paris (75001 à 75020), Lyon (69001 à 69009) et Marseille (13001 à 13016).
export const estArrondissement = (cp) =>
  /^(750(0[1-9]|1\d|20)|6900[1-9]|130(0[1-9]|1[0-6]))$/.test(String(cp ?? ''))
